<template>
  <div>
    <!-- Snackbar for showing download progress -->
    <v-snackbar v-model="loading" color="info" timeout="-1" top right>
      Download in progress, please wait...
    </v-snackbar>
    <v-container fluid>
      <v-row>
        <v-col v-for="(video, index) in videos" :key="index" cols="12" sm="6" md="4" lg="3">
          <v-card class="mx-auto" outlined>
            <v-responsive :aspect-ratio="16/9">
              <video :src="video.url" controls class="gallery-video"></video>
            </v-responsive>
            <v-card-title>{{ video.title }}</v-card-title>
            <v-card-subtitle>{{ video.description }}</v-card-subtitle>
            <v-card-actions>
              <v-btn @click.stop="downloadVideo(video.url)"  download color="primary">Download</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import videosData from '@/assets/stock-videos.json'; // JSON file containing video data

export default {
  data() {
    return {
      videos: videosData, // Load videos from JSON
      loading: false, // Flag to indicate download progress
    };
  },
  methods: {
    downloadVideo(url) {
      this.loading = true; // Set loading to true when the download starts
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);  // Create a URL for the blob
          link.download = name;  // Set the file name for the download
          document.body.appendChild(link);  // Append the link to the DOM
          link.click();  // Trigger the download
          document.body.removeChild(link);  // Clean up and remove the link from the DOM
          this.loading = false; // Set loading to false after the download completes
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
          this.loading = false; // Set loading to false if there's an error
        });
      }
  },
};
</script>

<style scoped>
  .gallery-video {
    width: 100%;
    cursor: pointer;
  }
</style>